import { PdfLine } from "./pdfReader";
import { PatientDoorReportData } from "./patientVisitData";

/****
 * We assume this pdf report is constant and won't change in the near future, it's super hacky and will break at some point
 * @author Avi Garfinkel, avi@kahun.com - Oct 3rd, 2022
 * @param lines - Pdf lines read from the pdf file using the pdfReader.ts
 */
const REPORT_TITLE_INDEX = 1;
const REPORT_TITLE_INDEX_SHORT_DATE = 2; // Sometimes the date might be shorter than the title, so i might get its own row
const REPORT_DATA_INDEX = 3;
const REPORT_DATA_INDEX_SHORT_DATE = 4;
const REPORT_TITLE_MAGIC_STRING = "דלת";

enum REPORT_TITLE_ROW_INDICES {
  DOCTOR_NAME,
  DR_DEGREE,
  ADDRESS_CITY,
  ADDRESS_STREET_NUMBER,
  ADDRESS_STREET_NAME,
  CERTIFICATION,
  DATE,
  TEXT,
}

enum REPORT_TITLE_SHORT_DATE_ROW_INDICES {
  DATE,
  TEXT,
}
enum TABLE_ROW_INDICES {
  INDEX,
  HOUR,
  SET_BY,
  DOTS,
  PARTIAL_ID,
  PRIVATE_NAME,
  VISIT_TYPE,
}

const isShortDateTitle = (lines: PdfLine[]) =>
  lines?.[REPORT_TITLE_INDEX_SHORT_DATE]?.[
    REPORT_TITLE_SHORT_DATE_ROW_INDICES.TEXT
  ]?.includes?.(REPORT_TITLE_MAGIC_STRING);

export const isMaccabiDoorReport = (lines: PdfLine[]) => {
  return (
    lines?.[REPORT_TITLE_INDEX]?.[REPORT_TITLE_ROW_INDICES.TEXT]?.includes?.(
      REPORT_TITLE_MAGIC_STRING,
    ) ||
    isShortDateTitle(lines) ||
    false
  );
};

export const readMaccabiVisitReport: (
  lines: PdfLine[],
) => PatientDoorReportData[] = (lines: PdfLine[]) => {
  if (!isMaccabiDoorReport(lines))
    throw new Error(
      "Can't parse this pdf file, doens't seem like a propper door report",
    );

  const isShortDate = isShortDateTitle(lines);

  const visitDate = isShortDate
    ? lines[REPORT_TITLE_INDEX_SHORT_DATE][
        REPORT_TITLE_SHORT_DATE_ROW_INDICES.DATE
      ]
    : lines[REPORT_TITLE_INDEX][REPORT_TITLE_ROW_INDICES.DATE];

  return lines.reduce((acc, currentRow, index) => {
    if (
      index < (isShortDate ? REPORT_DATA_INDEX_SHORT_DATE : REPORT_DATA_INDEX)
    )
      return acc;
    return [
      ...acc,
      {
        name: currentRow[TABLE_ROW_INDICES.PRIVATE_NAME].toString(),
        partialId: currentRow[TABLE_ROW_INDICES.PARTIAL_ID].toString(),
        index: Number.parseInt(
          currentRow[TABLE_ROW_INDICES.INDEX].toString() as string,
        ),
        visitTime: currentRow[TABLE_ROW_INDICES.HOUR].toString(),
        submittedBy: currentRow[TABLE_ROW_INDICES.SET_BY].toString(),
        visitDate: visitDate.toString(),
        visitType:
          currentRow.length === 6
            ? currentRow[TABLE_ROW_INDICES.VISIT_TYPE].toString()
            : null,
      },
    ];
  }, [] as PatientDoorReportData[]);
};
